import PointsReceivedFrontCard from "./PointsReceivedFrontCard";

export default PointsReceivedFrontCard;
